/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-25 09:08:50
 * @LastEditTime: 2019-12-04 10:08:58
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import AppMap from './AppMap.vue'
// import router from './router/route.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/styles/common.css';
import './assets/styles/uiDialog.scss';

import 'babel-polyfill';



//导入api
import "../static/lib/FMMapClient.js";

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  
  // router,
  render: h => h(AppMap),
}).$mount('#appMap')
